const ReactDOM = require('react-dom-original');

function findDOMNode(instance) {
  if (instance == null) {
    return null;
  }

  if (instance.nodeType === 1) {
    return instance;
  }

  try {
    if (instance._reactInternals?.stateNode) {
      const node = instance._reactInternals.stateNode;
      if (node && node.nodeType === 1) {
        return node;
      }
    }

    if (instance._reactInternals?.child?.stateNode) {
      const node = instance._reactInternals.child.stateNode;
      if (node && node.nodeType === 1) {
        return node;
      }
    }
  } catch (error) {
    // ignore internals access errors
  }

  if (process.env.NODE_ENV === 'development') {
    console.warn('findDOMNode is deprecated. Library using it should be updated.');
  }

  return null;
}

if (!ReactDOM.findDOMNode) {
  ReactDOM.findDOMNode = findDOMNode;
}

const exportsTarget = ReactDOM;
exportsTarget.findDOMNode = findDOMNode;
Object.defineProperty(exportsTarget, '__esModule', { value: true });
exportsTarget.default = ReactDOM;
module.exports = exportsTarget;
